import { render, staticRenderFns } from "./UserProfileDemographic.vue?vue&type=template&id=968585d4"
import script from "./UserProfileDemographic.vue?vue&type=script&lang=js"
export * from "./UserProfileDemographic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports